"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyCommandStatusReason = exports.PolicyCommandStatus = exports.PolicyCommandType = exports.salesforcePolicyTermValues = exports.salesforcePolicyTermFromPolicyTermMonths = exports.policyTermMonthsFromSalesforcePolicyTerm = void 0;
exports.policyTermMonthsFromSalesforcePolicyTerm = {
    '1 Month': 1,
    '2 Month': 2,
    '3 Month': 3,
    '4 Month': 4,
    '6 Month': 6,
    '12 Month': 12,
    '120 Month (10 yr)': 120,
    '180 Month (15 yr)': 180,
    '240 Month (20 yr)': 240,
    '300 Month (25 yr)': 300,
    '360 Month (30 yr)': 360,
    Other: undefined,
};
exports.salesforcePolicyTermFromPolicyTermMonths = {
    1: '1 Month',
    2: '2 Month',
    3: '3 Month',
    4: '4 Month',
    6: '6 Month',
    12: '12 Month',
    120: '120 Month (10 yr)',
    180: '180 Month (15 yr)',
    240: '240 Month (20 yr)',
    300: '300 Month (25 yr)',
    360: '360 Month (30 yr)',
};
exports.salesforcePolicyTermValues = Object.keys(exports.policyTermMonthsFromSalesforcePolicyTerm);
var PolicyCommandType;
(function (PolicyCommandType) {
    PolicyCommandType["ADD_ACCOUNT_MANAGER"] = "ADD_ACCOUNT_MANAGER";
    PolicyCommandType["ADD_PRODUCER"] = "ADD_PRODUCER";
    PolicyCommandType["CREATE"] = "CREATE";
    PolicyCommandType["CREATE_HISTORICAL"] = "CREATE_HISTORICAL";
    PolicyCommandType["DELETE"] = "DELETE";
    PolicyCommandType["END_POLICY"] = "END_POLICY";
    PolicyCommandType["MIGRATE"] = "MIGRATE";
    PolicyCommandType["MIGRATE_ROLE_MAPPING"] = "MIGRATE_ROLE_MAPPING";
    PolicyCommandType["REMOVE_ACCOUNT_MANAGER"] = "REMOVE_ACCOUNT_MANAGER";
    PolicyCommandType["REMOVE_PRODUCER"] = "REMOVE_PRODUCER";
    PolicyCommandType["RENEW_AS_IS"] = "RENEW_AS_IS";
    PolicyCommandType["REPLICATE"] = "REPLICATE";
    PolicyCommandType["REPLICATE_EXISTING"] = "REPLICATE_EXISTING";
    PolicyCommandType["SALESFORCE_DELETE_POLICY"] = "SALESFORCE_DELETE_POLICY";
    PolicyCommandType["SALESFORCE_TRIGGER_BATCH_REPLICATION"] = "SALESFORCE_TRIGGER_BATCH_REPLICATION";
    PolicyCommandType["SALESFORCE_TRIGGER_REPLICATION"] = "SALESFORCE_TRIGGER_REPLICATION";
    PolicyCommandType["SET_RENEWAL_QUOTING_PLAN"] = "SET_RENEWAL_QUOTING_PLAN";
    PolicyCommandType["SYNC"] = "SYNC";
    PolicyCommandType["TRIGGER_BATCH_REPLICATION"] = "TRIGGER_BATCH_REPLICATION";
    PolicyCommandType["TRIGGER_REPLICATION"] = "TRIGGER_REPLICATION";
    PolicyCommandType["TRIGGER_SYNC"] = "TRIGGER_SYNC";
    PolicyCommandType["UPDATE_BILLING"] = "UPDATE_BILLING";
    PolicyCommandType["UPDATE_COMMISSION"] = "UPDATE_COMMISSION";
    PolicyCommandType["UPDATE_DATE_RANGE"] = "UPDATE_DATE_RANGE";
    PolicyCommandType["UPDATE_DETAILS"] = "UPDATE_DETAILS";
    PolicyCommandType["UPDATE_LINES_OF_COVERAGE"] = "UPDATE_LINES_OF_COVERAGE";
    PolicyCommandType["UPDATE_NOTES"] = "UPDATE_NOTES";
    PolicyCommandType["UPDATE_STATUS"] = "UPDATE_STATUS";
})(PolicyCommandType = exports.PolicyCommandType || (exports.PolicyCommandType = {}));
var PolicyCommandStatus;
(function (PolicyCommandStatus) {
    PolicyCommandStatus["PENDING"] = "PENDING";
    PolicyCommandStatus["COMPLETED"] = "COMPLETED";
})(PolicyCommandStatus = exports.PolicyCommandStatus || (exports.PolicyCommandStatus = {}));
var PolicyCommandStatusReason;
(function (PolicyCommandStatusReason) {
    PolicyCommandStatusReason["FAILED"] = "FAILED";
    PolicyCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
    PolicyCommandStatusReason["MIGRATED"] = "MIGRATED";
})(PolicyCommandStatusReason = exports.PolicyCommandStatusReason || (exports.PolicyCommandStatusReason = {}));
//# sourceMappingURL=policy-command.js.map